import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { CSV_MODAL_TYPES } from 'utils/admin-csv';
import { showSuccessToast } from 'shared-components/BaseToast/Toast';
import CSVModal from 'shared-components/CSVModal/CSVModal';
import BaseModal from 'shared-components/BaseModal/Modal';
import CloseButton from 'shared-components/CloseButton/CloseButton';
import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import { Radio } from 'shared-components';
import styles from './CartsPageModal.module.css';

const CartsPageModal = ({
  open,
  isSaleCart,
  closeModal,
  fetchCartsCallback,
}) => {
  const [radioSelection, setRadioSelection] = useState('');
  const [csvModalType, setCsvModalType] = useState(null);

  const closeCsvModal = () => setCsvModalType(null);

  const handleUploadSuccess = (updatedItemCount) => {
    if (
      csvModalType === CSV_MODAL_TYPES.addCarts ||
      csvModalType === CSV_MODAL_TYPES.addCartsRefills
    ) {
      showSuccessToast(
        'Successfully Added Carts',
        `${updatedItemCount} cart(s) were successfully added.`
      );
    }
    if (
      csvModalType === CSV_MODAL_TYPES.removeCarts ||
      csvModalType === CSV_MODAL_TYPES.removeCartsRefills
    ) {
      showSuccessToast(
        'Successfully Removed Carts',
        `${updatedItemCount} cart(s) were successfully removed.`
      );
    }
    setCsvModalType(null);
  };

  const handleRadio = (e) => {
    setRadioSelection(e.target.value);
  };

  const handleClickNext = () => {
    const modalType = isSaleCart ? radioSelection : `${radioSelection}Refills`;
    setCsvModalType(modalType);
    closeModal();
  };

  return (
    <>
      <CSVModal
        type={csvModalType}
        title="Upload Carts CSV"
        onClickClose={closeCsvModal}
        updateData={fetchCartsCallback}
        onUploadSuccess={handleUploadSuccess}
      />
      <BaseModal isOpen={!!open}>
        <div className={styles.modal}>
          <CloseButton onClick={closeModal} />
          <h3>Upload Carts CSV</h3>
          <p>What is the purpose of this CSV?</p>
          <div className={styles.radioContainer}>
            <Radio
              label="Adding Items"
              value={CSV_MODAL_TYPES.addCarts}
              onChange={handleRadio}
              checked={radioSelection === CSV_MODAL_TYPES.addCarts}
              id="add-carts"
              name={CSV_MODAL_TYPES.addCarts}
            />
            <Radio
              label="Removing Items"
              value={CSV_MODAL_TYPES.removeCarts}
              onChange={handleRadio}
              checked={radioSelection === CSV_MODAL_TYPES.removeCarts}
              id="remove-carts"
              name={CSV_MODAL_TYPES.removeCarts}
            />
          </div>
          <div className={styles.buttonContainer}>
            <Button
              buttonType={BUTTON_TYPES.TERTIARY_INVERSE}
              onClick={closeModal}
            >
              Cancel
            </Button>
            <Button onClick={handleClickNext} disabled={!radioSelection}>
              Next
            </Button>
          </div>
        </div>
      </BaseModal>
    </>
  );
};

CartsPageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  isSaleCart: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  fetchCartsCallback: PropTypes.func.isRequired,
};

export default CartsPageModal;
